import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';

import store from 'Redux/store';
import { getWishlistOnSale } from 'Redux/ducks/wishlist';
import BrowseButton from 'Components/Utility/BrowseButton';
import ProductCarousel from 'Components/HomePage/ProductCarousel';
import SkeletonCarousel from 'Components/Utility/Skeleton/SkeletonCarousel';
import ItemList from 'Components/Product/Seo/ItemList';
import 'Containers/HomePage/WishlistMostWantedSection.scss';

const WishlistMostWanted = ({
  loadedHits,
  onSaleWishlist,
  authenticated,
  fetchWishlistOnSale,
  noBackground,
  hitCardNameTag,
}) => {
  const [hits, setHits] = useState([]);
  const [carouselToShow, setCarouselToShow] = useState(authenticated ? 'wishlist' : 'mostWanted');
  const [isChrome, setChrome] = useState(false);

  useEffect(() => {
    if (authenticated) {
      fetchWishlistOnSale();
    } else {
      setHits(loadedHits);
      setCarouselToShow('mostwanted');
      store.dispatch({ type: 'frontend/wishlist/WISHLIST_MOST_WANTED_SECTION', payload: { type: 'Most Wanted' } });
    }
  }, [authenticated]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (onSaleWishlist && onSaleWishlist.length >= 3) {
      setHits(onSaleWishlist);
      setCarouselToShow('wishlist');
      store.dispatch({ type: 'frontend/wishlist/WISHLIST_MOST_WANTED_SECTION', payload: { type: 'Wishlist' } });
    } else {
      setHits(loadedHits);
      setCarouselToShow('mostwanted');
      store.dispatch({ type: 'frontend/wishlist/WISHLIST_MOST_WANTED_SECTION', payload: { type: 'Most Wanted' } });
    }
  }, [onSaleWishlist, loadedHits]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (window.chrome) {
      setChrome(true);
    }
  }, []);

  return (
    <section
      className={classNames(
        'wishlist-most-wanted-section',
        { 'no-background': noBackground },
      )}
    >
      <div className="container">
        {carouselToShow === 'wishlist' &&
          <div className="wishlist-heading-container">
            <div className="title-container">
              <div className="icon-container">
                <FontAwesomeIcon icon={faHeart} />
              </div>
              <h2 className="mb-0">
                <FormattedMessage id="wishlist-most-wanted.wishlist.title" defaultMessage="Your Wishlist Special Offers" />
              </h2>
            </div>
            <div className="button-container">
              <Link to="/wishlist" className="view-all-btn btn btn-outline-primary btn-sm">
                <FormattedMessage id="wishlist-most-wanted.wishlist.button" defaultMessage="View wishlist" />
              </Link>
            </div>
          </div>
        }
        {carouselToShow === 'mostwanted' &&
          <div className="section-heading-container">
            <ItemList hits={hits} title="Most Wanted Games" />
            <h2 className="section-title">
              <FormattedMessage id="wishlist-most-wanted.most-wanted.title" defaultMessage="Most Wanted Games" />
            </h2>
            <BrowseButton className={'view-all-btn'} location={'most-wanted'} />
          </div>
        }
        {isEmpty(hits) &&
          <SkeletonCarousel slidesToShow={3} />
        }
        {!isEmpty(hits) &&
          <ProductCarousel
            leftAlign
            hitData={hits}
            slidesToShow={3}
            viewAllLocation={carouselToShow === 'mostwanted' ? 'most-wanted' : 'wishlist'}
            hitCardNameTag={hitCardNameTag}
          />
        }
        <div className="message-container">
          {isChrome &&
            <FormattedMessage
              id="wishlist-most-wanted.dyk-bottom-message"
              defaultMessage="{dyk} you can now set your Fanatical wishlist to automatically synchronise with your Steam wishlist in your account. {link}"
              values={{
                dyk: <strong><FormattedMessage id="wishlist-most-wanted.dyk-bottom-message.dyk" defaultMessage="Did you know..." /></strong>,
                link: <Link to="/wishlist" className="brand-link"><FormattedMessage id="wishlist-most-wanted.dyk-bottom-message.link" defaultMessage="Find out more..." /></Link>,
              }}
            />
          }
        </div>
      </div>
    </section>
  );
};

WishlistMostWanted.propTypes = {
  onSaleWishlist: PropTypes.arrayOf(PropTypes.shape({})),
  loadedHits: PropTypes.arrayOf(PropTypes.shape({})),
  authenticated: PropTypes.bool,
  fetchWishlistOnSale: PropTypes.func.isRequired,
  noBackground: PropTypes.bool,
  hitCardNameTag: PropTypes.string,
};

WishlistMostWanted.defaultProps = {
  onSaleWishlist: [],
  loadedHits: [],
  authenticated: false,
  noBackground: false,
  hitCardNameTag: 'div',
};

const mapStateToProps = ({
  wishlist: { onSaleWishlist },
  auth: { authenticated },
}) => ({
  onSaleWishlist,
  authenticated,
});

export default connect(mapStateToProps, {
  fetchWishlistOnSale: getWishlistOnSale,
})(WishlistMostWanted);
